module.exports = __webpack_public_path__ + "static/img/3.37b6e005.png";